import { Link, Redirect } from 'react-router-dom'
import { NavMenus } from '../../constants/Enum'
import { OrderType } from '../../constants/EnumType';
import { useContext } from 'react'
import UserContext from '../../contexts/UserContext'
import { groupBy } from 'lodash'

import { Permission } from '../../constants/Permission';

const renderMenu = (menu) => 
  <Link key={menu.path} to={menu.path} className='flex items-center gap-2 p-3 rounded-lg hover:bg-black hover:bg-opacity-40 '>
    {<menu.logo size={75} className={menu.color} />}
    <div>
      <h5 className='mb-2 font-bold'>{menu.title}</h5>
      <small className='font-light'>{menu.description}</small>
    </div>
  </Link>

const Home = () => {
  const { user } = useContext(UserContext)

  const permissions = Permission[user.department][user.line || OrderType.All][user.role.toUpperCase()]
  if (permissions.length > 1) {
    const groupByCatMenus = groupBy(NavMenus.filter(menu => menu.active), 'category')

    return <div className='relative text-white home-container'>
      <div className='absolute top-0 bottom-0 left-0 right-0 bg-white bg-opacity-20'></div>
      <div className="absolute">
        {process.env.REACT_APP_ENV !== 'PRD' ? <div className="inline-flex items-center w-full px-6 py-5 mb-3 text-base text-yellow-700 bg-yellow-100 rounded-lg" role="alert">
          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-triangle" className="w-4 h-4 mr-2 fill-current" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
            <path fill="currentColor" d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
          </svg>
          นี่คือระบบทดสอบ ตอนนี้ระบบจริง (EPP, PRD) พร้อมใช้งานจริงแล้ว กรุณาไปกดไปที่ <a 
            href="https://paperless.pd.neo-corporate.com"
            target="_blank"
            rel="noreferrer"
            className="pl-3 font-bold text-yellow-800">https://paperless.pd.neo-corporate.com
          </a>
        </div> : null}
        <div className='p-6 mr-4 space-y-2 bg-black bg-opacity-50'>
          <h1>สวัสดี {user?.name || user?.givenName || user?.username || ''}, {user?.role || ''}</h1>
          <h4>แผนก {user?.division || ''}</h4>
          <h6 className='py-3'>เลือกเมนูที่ต้องการ</h6>
          <div className='grid gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4'>
            {permissions.map(page => {
              if (!groupByCatMenus.hasOwnProperty(page)) return null
              const menus = groupByCatMenus[page]
              if (menus.length > 1) {
                // multi menu
                return menus.map(menu => renderMenu(menu));
              } else {
                // single menu
                const menu = menus[0]
                return renderMenu(menu)
              }
            })}
          </div>
        </div>
      </div>
    </div>
  }
  return <Redirect to={permissions[0]} />
}

export default Home